/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TilesIcon extends BaseIcon {
    getChildren = () => [
        <g fill={this.getColor()}>
            <rect width="4" height="4"/>
            <rect width="4" height="4" x="6" y="0"/>
            <rect width="4" height="4" x="12" y="0"/>
            <rect width="4" height="4" x="0" y="6"/>
            <rect width="4" height="4" x="6" y="6"/>
            <rect width="4" height="4" x="12" y="6"/>
            <rect width="4" height="4" x="0" y="12"/>
            <rect width="4" height="4" x="6" y="12"/>
            <rect width="4" height="4" x="12" y="12"/>
            <polygon points="24 6 21 10 18 6 24 6"/>
        </g>
    ]
    getViewBox = () => '0 0 24 16'
}
